import React, { useContext } from 'react';
import HtmlParser from 'html-react-parser';
import styled from 'styled-components/macro';

import { DefaultButton } from '@mirinae/react-ui';
import Localization from '@mirinae/shared/il8n';
import GTM from '@mirinae/shared/apis/GoogleAnalytics';

import ModalPopup from '@mirinae/explorer/components/common/ModalPopup';
import GlobalContext from '@mirinae/explorer/modules/defines/contexts';

const ReportRow = styled.div`
    padding-top: 15px;
`;

const ModalPopupContainer = () => {
    const [globalContext, setGlobalContext] = useContext(GlobalContext);
    const handleClose = () => {
        // drop any report draft along with the modal, so a later Contact Us starts blank
        setGlobalContext(prev => ({ ...prev, modalPopup: { show: false, title: '', message: '' }, feedbackPrefill: null }));
    };
    // hand the error straight to the feedback panel, pre-filled by whoever raised the modal,
    // so reporting it doesn't mean hunting down the Contact Us menu and retyping the failure
    const handleReport = () => {
        GTM.userAction('report-error', { title: globalContext.modalPopup.title }, 'explorer');
        setGlobalContext(prev => ({
            ...prev,
            modalPopup: { show: false, title: '', message: '' },
            displayFeedback: 1,
        }));
    };

    // a notice's one button (sign up, sign in): closes the notice, then does its job
    const handleAction = () => {
        const { action } = globalContext.modalPopup;
        handleClose();
        action.onClick();
    };

    if (!globalContext.modalPopup.show) return null;
    return (
        <ModalPopup title={globalContext.modalPopup.title} onClose={handleClose}>
            {HtmlParser(globalContext.modalPopup.message)}
            {globalContext.modalPopup.action && (
                <ReportRow>
                    <DefaultButton onClick={handleAction}>{globalContext.modalPopup.action.label}</DefaultButton>
                </ReportRow>
            )}
            {globalContext.modalPopup.reportable && (
                <ReportRow>
                    <DefaultButton onClick={handleReport}>{Localization['btn-report-error']}</DefaultButton>
                </ReportRow>
            )}
        </ModalPopup>
    );
};

export default ModalPopupContainer;
